module.exports = __webpack_public_path__ + "img/94da1cc.jpg";